module.exports = __webpack_public_path__ + "img/bg_mall.bd1627a9.jpg";